module.exports = __webpack_public_path__ + "img/tl.469f6602.jpg";